import React from "react";
import cn from "classnames";

export const Input = ({
  className,
  name,
  isError,
  error,
  register = (e) => console.log(e),
  ...props
}) => {
  return (
    <>
      <input
        className={cn(
          "w-full rounded-[10px] p-3 outline outline-1 outline-gray-modern-300 text-text-md placeholder:text-text-light bg-white disabled:bg-gray-modern-50 text-text-black transition focus:outline-primary-500",
          {
            "!focus:outline-error-600 !outline-error-600 !bg-error-25": isError,
          },
          className
        )}
        {...register(name)}
        {...props}
      />
    </>
  );
};
